import React, { useEffect, useState } from "react";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import TarjetachatUsuario from "./componentesChat/tarjetaChatUsuario";
import TarjetachatAventura from "./componentesChat/tarjetaChatAventuras";
import Button from "@mui/joy/Button";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import { useNavigate } from "react-router-dom";

import "../../css/footeramigos.css";

export default function DisenoChat({
  misaventuras,
  amigos,
  funcion,
  selectaventura,
  margin,
}) {
  let navigate = useNavigate();

  return (
    <div style={{ marginLeft: margin }}>
      <Box
        sx={{
          width: { md: 350, xs: "100vw" },
          height: "100vh",
          borderRight: "1px solid #ccc",
          overflowY: "auto",
        }}
      >
        <Box sx={{ width: "80%", margin: 3, marginTop: 5 }}>
          {margin ? null : (
            <Button
              startDecorator={<KeyboardReturnIcon />}
              variant="plain"
              color="neutral"
              size="sm"
              sx={{ marginBottom: 1 }}
              onClick={() => {
                navigate("/");
              }}
            >
              Inicio
            </Button>
          )}
          <Typography level="title-lg">Tus Compañeros y Aventuras</Typography>
          <Typography level="body-xs" sx={{ marginTop: 1 }}>
            Selecciona un chat para comunicarte con tus compañeros o grupos de
            aventuras.
          </Typography>
        </Box>
        {misaventuras.map((x, index) => {
          return (
            <TarjetachatAventura
              titulo={x.titulo}
              foto={x.imagen}
              pais={x.pais}
              ciudad={x.ciudad}
              key={index}
              leido={x.leido}
              selectaventura={() => {
                selectaventura(x);
              }}
            />
          );
        })}
        {amigos.map((x, index) => {
          return (
            <TarjetachatUsuario
              nombre={x.nombre}
              foto={x.foto_de_perfil}
              interes_personal={x.intereses}
              edad={x.fecha_de_nacimiento}
              leido={x.leido}
              key={index}
              funcion={() => {
                funcion(x);
              }}
            />
          );
        })}
      </Box>
    </div>
  );
}
